import React, { useState, useEffect } from 'react';
import { MDBRow, MDBCol } from 'mdbreact';
import PropTypes from 'prop-types';

import PageStructure from 'components/PageStructure';

import PersonalDevelopmentTable from 'pages/PDI/InternalComponents/PersonalDevelopmentTable';

import endpoints from 'services/endpoints';
import useFetch from 'hooks/useFetch';

const { getPDITeam } = endpoints;

export default function TeamEvaluation({ user }) {
  const { id_funcionario: idFuncionario } = user;
  const [teamInformations, setTeamInformations] = useState([]);
  const [observer, setObserver] = useState(false);

  const [allTeam] = useFetch(`${getPDITeam}/${idFuncionario}`, observer);

  useEffect(() => {
    (async () => {
      const response = await allTeam;
      setTeamInformations(response);
    })();
  }, [allTeam]);

  return (
    <PageStructure
      title="Plano de Desenvolvimento Individual - Avaliação de Equipe"
      subtitle="Atribua um mediador para cada membro da sua equipe.
      Se necessário, você pode também atribuir um avaliador. Você pode ordenar a lista por 'funcionários' ou 'status'"
    >
      <MDBRow>
        <MDBCol lg="12">
          <PersonalDevelopmentTable
            setObserver={setObserver}
            userId={idFuncionario}
            data={teamInformations}
          />
        </MDBCol>
      </MDBRow>
    </PageStructure>
  );
}

TeamEvaluation.defaultProps = {
  user: {},
};

TeamEvaluation.propTypes = {
  user: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
};
